import { z } from 'zod';
import { WorldGenerationSchema } from './world-settings.js';

export const RegenerateWorldSchema = z
  .object({
    confirmName: z.string().min(1).max(100),
    preservePlayers: z.boolean(),
    seedMode: z.enum(['random', 'current', 'specified']),
    seed: z
      .string()
      .min(1)
      .max(200)
      .refine((value) => !/[\r\n\0]/.test(value), '改行・NUL は指定できません')
      .optional(),
  })
  .strict()
  .refine((v) => v.seedMode !== 'specified' || v.seed !== undefined, 'シードを指定してください');
export type RegenerateWorld = z.infer<typeof RegenerateWorldSchema>;
export const WorldGenerationViewSchema = z.object({
  current: WorldGenerationSchema,
  properties: z.record(z.string(), z.string()),
  pending: WorldGenerationSchema.optional(),
  datapacks: z.array(z.string()),
  currentSeed: z.string().optional(),
});
export type WorldGenerationView = z.infer<typeof WorldGenerationViewSchema>;
export const ServerWorldGenerationViewSchema = WorldGenerationViewSchema.extend({
  customWorldTypes: z.array(z.object({ id: z.string(), label: z.string() })),
  modifiers: z.array(z.object({ label: z.string(), message: z.string() })),
});
export type ServerWorldGenerationView = z.infer<typeof ServerWorldGenerationViewSchema>;
/** latest: 今の起動、all: 保存されているすべてのログ、crash: crash-reports/ のクラッシュレポートと JVM の hs_err */
export const LogScopeSchema = z.enum(['latest', 'all', 'crash']);
export type LogScope = z.infer<typeof LogScopeSchema>;
export const LogChunkSchema = z.object({ data: z.string().max(700000), done: z.boolean() });
export const LogDownloadQuerySchema = z.object({ scope: LogScopeSchema.default('latest') }).strict();
export const AuditFilterSchema = z
  .object({
    start: z.iso.date().optional(),
    end: z.iso.date().optional(),
    requestedBy: z.string().max(100).optional(),
    via: z.enum(['web', 'mcp', 'system']).optional(),
    operation: z.string().max(100).optional(),
    target: z.string().max(100).optional(),
    result: z.string().max(100).optional(),
  })
  .strict()
  .refine((v) => !v.start || !v.end || v.start <= v.end, '期間が逆です');
export type AuditFilter = z.infer<typeof AuditFilterSchema>;
